import React, { FC } from 'react';
import { StrategySelector } from '@app/screens/liquidity/AddLiquidityV3/components/StrategySelector';
import { AmountsInput } from '@app/screens/liquidity/AddLiquidityV3/components/AmountsInput';
import { CreatePositionWithKpNft } from '@app/screens/liquidity/AddLiquidityV3/components/CreatePositionWithKpNft';
import { useDerivedLiquidityInfo } from '@app/state/mintStore';
import { Currency } from '@cryptoalgebra/kim-sdk';

interface Props {
  poolAddress: string | undefined;
  currencyA: Currency | undefined;
  currencyB: Currency | undefined;
}

export const AddLiquidityBySteer: FC<Props> = ({
  poolAddress,
  currencyA,
  currencyB
}) => {
  const mintInfoWithProvider = useDerivedLiquidityInfo(
    currencyA,
    currencyB,
    poolAddress,
    currencyA
  );

  return (
    <>
      <StrategySelector
        poolAddress={poolAddress}
        mintInfo={mintInfoWithProvider}
      />
      <AmountsInput
        currencyA={currencyA}
        currencyB={currencyB}
        mintInfo={mintInfoWithProvider}
      />
      <CreatePositionWithKpNft
        mintInfo={mintInfoWithProvider}
        currencyA={currencyA}
        currencyB={currencyB}
      />
    </>
  );
};
